import { render, staticRenderFns } from "./Fchz.vue?vue&type=template&id=56f6d01e&scoped=true&"
import script from "./Fchz.vue?vue&type=script&lang=js&"
export * from "./Fchz.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=56f6d01e&prod&scoped=true&lang=css&"
import style1 from "./Fchz.vue?vue&type=style&index=1&id=56f6d01e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6d01e",
  null
  
)

export default component.exports